import React from 'react';
import {
  Box,
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Link,
} from '@material-ui/core';
import { Rating } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ratingContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: '8px',
      marginTop: '12px',
      marginBottom: '12px',
    },
    ratingAction: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '0',
      border: '0',
      background: 'transparent',
      textDecoration: 'none',
      cursor: 'pointer',
      '&:hover $ratingText': {
        color: theme.palette.primary.main,
      },
      '&:hover $reviewCountInteractive': {
        color: theme.palette.primary.dark,
        textDecoration: 'underline',
      },
    },
    ratingStars: {
      marginBottom: '0',
    },
    ratingText: {
      fontSize: '14px',
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    reviewCount: {
      fontSize: '12px',
      color: theme.palette.text.secondary,
      opacity: 0.7,
      marginTop: '0',
      lineHeight: 1.5,
    },
    reviewCountInteractive: {
      color: theme.palette.primary.main,
    },
  }),
);

interface RatingDisplayProps {
  rating: number;
  reviewCount: number;
  onReviewsClick?: () => void;
}

export const RatingDisplay: React.FC<RatingDisplayProps> = ({
  rating,
  reviewCount,
  onReviewsClick,
}) => {
  const classes = useStyles();
  const reviewLabel =
    reviewCount === 0
      ? '(Be the first to rate!)'
      : `(${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'})`;

  return (
    <Box className={classes.ratingContainer}>
      {onReviewsClick ? (
        <Link
          component="button"
          type="button"
          underline="none"
          onClick={onReviewsClick}
          className={classes.ratingAction}
          aria-label="Open reviews"
        >
          <Rating
            value={rating}
            precision={0.1}
            readOnly
            size="small"
            className={classes.ratingStars}
          />
          {reviewCount > 0 && (
            <Typography className={classes.ratingText}>
              {rating.toFixed(1)}
            </Typography>
          )}
          <Typography
            component="span"
            className={`${classes.reviewCount} ${classes.reviewCountInteractive}`}
          >
            {reviewLabel}
          </Typography>
        </Link>
      ) : (
        <>
          <Rating
            value={rating}
            precision={0.1}
            readOnly
            size="small"
            className={classes.ratingStars}
          />
          {reviewCount > 0 && (
            <Typography className={classes.ratingText}>
              {rating.toFixed(1)}
            </Typography>
          )}
          <Typography component="span" className={classes.reviewCount}>
            {reviewLabel}
          </Typography>
        </>
      )}
    </Box>
  );
};
